import { type IValidateBankDetails, narrationValidation } from 'BreetHelpers';
import type { ChangeEvent } from 'react';
import * as yup from 'yup';

export interface IDialogAddBeneficiary {
	noBeneficiary?: boolean;
	intent?: addBeneficiaryIntentType;
	onSuccess?: () => void;
}

export interface INoBeneficiary {
	intent?: string;
	header?: boolean;
	addAccount: () => void;
}

const ValidatedBankDetailsSchema = yup.object({
	accountNumber: yup.string().default(''),
	type: yup.string().default(''),
	bankName: yup.string().default(''),
	accountName: yup.string().default(''),
});

export type ValidatedBankDetailsSchemaType = yup.InferType<typeof ValidatedBankDetailsSchema>;

export const BankDetailsSchema = yup.object({
	accountNumber: yup.string().required('Account number is required'),
	bankId: yup.string().required('Bank is required'),
	validatedBankDetails: ValidatedBankDetailsSchema,
	narration: narrationValidation,
});

export type BankDetailsSchemaType = yup.InferType<typeof BankDetailsSchema>;

export const defaultValidatedBankDetails: IValidateBankDetails = {
	accountName: '',
	accountNumber: '',
	bankName: '',
	type: '',
};

export interface IBankSelectForm {
	onHandleBankId?: (valueArg: string) => void;
	validatedAccountName?: string;
	handleAccountNumber?: (e: ChangeEvent<HTMLInputElement>) => void;
	accountNumberMessage?: string;
	bankErrorMessage?: string;
	value?: string;
	fetchBankDetails?: () => void;
	isFetchingBankDetails?: boolean;
}

export type addBeneficiaryIntentType = 'enable automatic settlement' | 'initiate a withdrawal';
